/**
 * Customize which models activity charts are to be shown when data is pulled for an app
 * modelName: display label
 * eg.
 * model_as_per_models_json: "Model As Per Model's Json"
 */

/**
 * Available chart models
 */
export const analyticsChartModels = {
  moment: "Moments",
  landmark: "Landmarks",
  media: "Media",
};

/**
 * @param appId "id_list" file in backend.
 * @param charts array of keys from "analyticsChartModels"
 */
interface IChartDisplayConfig {
  appId: string;
  charts: Array<keyof typeof analyticsChartModels>;
}

/**
 * Chart configuration for apps
 */
export const appChartConfig: IChartDisplayConfig[] = [
  {
    appId: "Defining Moments",
    charts: ["moment", "media"],
  },
  {
    appId: "Landmarks",
    charts: ["landmark", "media"],
  },
];

// export const chartColors = [
//   "#003f5c",
//   "#444e86",
//   "#955196",
//   "#dd5182",
//   "#ff6e54",
//   "#ffa600",
// ];

export const chartColors = [
  "#fb8ab3",
  "#c27bcc",
  "#af93fa",
  "#99aef8",
  "#8bdafb",
  "#6bbdb6",
  "#b8da92",
  "#e2e885",
  "#f5b776",
  "#e2cb55",
  "#ed7376",
];
